import { PromptPopup } from "@/components/prompt/PromptPopup.js";
import { Button } from "@rosette/web_components/src/ui/Button.js";
import type { ReactNode } from "react";
import React, { startTransition, useCallback, useState } from "react";
import { LoginFormModal } from "@/components/auth/LoginForm.js";
import { SocialSignInButtons } from "@/components/auth/SocialSignInButtons.js";
import { OrSeparator } from "@rosette/web_components/src/generic/OrSeparator.js";


interface LoginPromptProps {
    children?: ReactNode;
    visible: boolean;
    close: () => void;
    onNoThanks: () => void;
    title?: string;
    noThanksText?: string;
    redirectPathname?: string;
}


export function LoginPrompt({
    children, visible, close, onNoThanks, title, noThanksText, redirectPathname,
}: LoginPromptProps) {
    const [showLogin, setShowLogin] = useState(false);
    const closeModal = useCallback(() => setShowLogin(false), [setShowLogin]);
    return (
        <>
            <PromptPopup
                title={title ?? "Would you like to sign in?"}
                visible={visible}
                close={close}>

                <div className="text-base">
                    {children}
                </div>

                <div className="flex flex-col w-full gap-4">
                    <SocialSignInButtons redirectPathname={redirectPathname ?? null} />
                    <OrSeparator />

                    <Button
                        tone="accent"
                        size="lg"
                        className="w-full"
                        onClick={() => startTransition(() => {
                            close();
                            setShowLogin(true);
                        })}>

                        Sign in
                    </Button>

                    <Button
                        tone="primary"
                        size="lg"
                        className="w-full"
                        href="/register">

                        Register
                    </Button>

                    <Button
                        size="lg"
                        className="w-full"
                        onClick={onNoThanks}>

                        {noThanksText ?? "No thanks"}
                    </Button>
                </div>
            </PromptPopup>

            <LoginFormModal
                visible={showLogin}
                close={closeModal} />
        </>
    );
}
